export default "__VITE_ASSET__Bnd6$J0q__"